export default {
  providersView: {
    title: {
      section: 'PRODUCTEURS',
      type: {
        QC: 'Disponible au Québec',
        ON: 'Disponible en Ontario',
      },
      goTo: {
        QC: 'Producteurs disponible au Québec',
        ON: 'Producteurs disponible en Ontario',
      },
      search: 'Trouver un producteur',
    },
  },
  providerView: {
    label: {
      producerProduct: 'Produits',
      relatedArticles: 'articles en lien',
    },
  },
  providerCard: {
    unavailableContent: 'Le contenu du producteur n\'est pas disponible',
  },
  providerDescription: {
    link: 'En lire plus',
  },
  filters: {
    label: {
      selectedFilters: 'Filtres',
      attributes: 'Attributs',
      countries: 'Pays',
      regions: 'Regions',
      countryRegion: 'Origine',
      all: 'Tout',
    },
    button: {
      cancel: 'Annuler',
      filter: 'Filtrer',
    },
  },
};
